import React from "react";

/** Dismissible inline error banner (alerts API messages above a form region). */
const ErrorToast = ({ message, onDismiss, className = "" }) => {
  if (!message) return null;
  return (
    <div
      role="alert"
      className={`flex gap-3 rounded-lg border border-theme-border bg-theme-secondary px-3 py-2.5 ${className}`}
    >
      <p className="min-w-0 flex-1 font-mono text-xs text-theme-text leading-relaxed">{message}</p>
      <button
        type="button"
        aria-label="Dismiss message"
        className="shrink-0 rounded p-1 text-theme-dim hover:text-theme-text hover:bg-theme-main focus:outline-none focus:ring-1 focus:ring-theme-accent/50"
        onClick={onDismiss}
      >
        <span className="material-symbols-outlined leading-none text-base" aria-hidden>
          close
        </span>
      </button>
    </div>
  );
};

export default ErrorToast;
